import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";

import { ReportsPageStartContent } from "./reports.page-start.content";

export const ReportsPageStart: FC = () => {
  return (
    <PageContextWrapper entity="report">
      <ReportsPageStartContent />
    </PageContextWrapper>
  );
};
